export default {
  notAvailableTextColor: Styles.color.grey.three,
};
